export enum TransfersPerView {
  Mobile = 4,
  Desktop = 6,
}
